import { GlobalEvents, useEventBusListener } from '../../../..';
export function useUserAuthorizationOrganizationsEventListener(eventReceivedCallback) {
    useEventBusListener(GlobalEvents.RETRIEVED_USER_AUTHORIZATION_ORGANIZATIONS, eventReceivedCallback, {
        once: false,
    });
}
